import bridge from './vue-constructor-bridge';
import NewRelicMonitoringService from './services/new-relic-plugin-service';

const NewRelicEventTrackingPlugin = {
  install(app, { store }) {
    const newRelicMonitoringService = NewRelicMonitoringService(store);

    // Set on the bridge so store/service files that do
    // `import bridge from '@/plugins/vue-constructor-bridge'; bridge.triggerNewRelicEvent(...)` can find it.
    bridge.triggerNewRelicEvent = newRelicMonitoringService.triggerNewRelicEvent;

    app.config.globalProperties.$triggerNewRelicEvent = newRelicMonitoringService.triggerNewRelicEvent;
  }
};

export default NewRelicEventTrackingPlugin;

